import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  SEEN: "Previous Winners Seen",
  OPEN: "Previous Winners Modal Opened",
  NAVIGATE_TO: COMMON_EVENT_NAMES.NAVIGATED,
  SWIPE_SIDE: "swipe"
};
